import { TermsAndConditions } from "@/components/termsAndConditions/TermsAndConditions";

export const TermsAndConditionsPage = () => {
  return (
    <div className="w-full">
      <TermsAndConditions />
    </div>
  );
};
